/**
 * Constants for install verification tag status messages
 */

const COMMUNICATION_STATUS = {
  NO_COMMUNICATION: 'No device communication detected',
  TIMEOUT_EXCEEDED: 'Device communication timeout exceeded',
  ACTIVE: 'Device communication is active',
} as const;

export const INSTALL_VERIFICATION_CONSTANTS = {
  COMMUNICATION_STATUS,
} as const;
